import { useCallback } from 'react';

import { UploadStepsEnum } from '../../../../constants/addressBook';
import { useUploadModal } from '../UploadModalContext';

interface IProps {
  onClose: () => void;
}

export const useModalClose = ({ onClose }: IProps) => {
  const { currentStep, isLoading, isImportBlocked, handleCloseWithSuccess } = useUploadModal();

  return useCallback(() => {
    if (currentStep === UploadStepsEnum.Import && !isLoading && !isImportBlocked) {
      handleCloseWithSuccess(onClose);
    } else {
      onClose();
    }
  }, [currentStep, isLoading, isImportBlocked, handleCloseWithSuccess, onClose]);
};
